import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback, useSagaEffect} from "../store/sagas";
import {apiGet, apiPost, useGetRequestData} from "./client";

export const useEditPost = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, content, reason) {
        return yield call(apiPost, `/api/v2/action/edit`, {
            id,
            type: 'post',
            content,
            reason,
        });
    }, []));
};

export const useEditComment = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (id, content, reason) {
        return yield call(apiPost, `/api/v2/action/edit`, {
            id,
            type: 'comment',
            content,
            reason,
        });
    }, []))
};

export const useRawContent = (feedbackCh, id, type, setData) => {
    useSagaEffect(feedbackCh, useCallback(function* () {
        const url = `/api/v2/${type}/raw?id=${id}`;
        const {content} = yield call(apiGet, url);
        setData(content);
    }, [id, type, setData]));
};

export const useEditHistory = (feedbackCh, id, type) =>
    useGetRequestData(feedbackCh, `/api/v2/revisions/history?id=${id}&type=${type}`)?.revisions;